import React, { Fragment } from 'react';
import './chapterHeader.scss';
import VideoLoop from '../VideoLoop/VideoLoop';
import { chapterHeaderData } from './chapterHeaderData.js';

function ChapterHeader({ chIndex }) {
  const { narrow, wide, loopD, loopM, images, reverse } = chapterHeaderData[chIndex];
  return (
    <section className={reverse ? 'chapterHeader chapterHeader--reverse' : 'chapterHeader'}>
      {chIndex < 2 && chapterHeaderData[chIndex] && (
        <Fragment>
          <img src={narrow} alt="" className="chapterHeader__static chapterHeader__narrow" />
          <VideoLoop
            data={{
              videoD: loopD,
              videoM: loopM
            }}
          />
          <img src={wide} alt="" className="chapterHeader__static chapterHeader__wide" />
        </Fragment>
      )}
      {chIndex > 1 && chapterHeaderData[chIndex] && (
        <Fragment>
          <VideoLoop
            data={{
              videoD: loopD,
              videoM: loopM
            }}
          />
          <img src={images} alt="" className="chapterHeader__static chapterHeader__images" />
        </Fragment>
      )}
    </section>
  );
}

export default ChapterHeader;
